// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"320":"1fb26350","510":"1d71abc9","688":"2123e8ff","832":"5c2e0169"}[chunkId] + ".chunk.js";
};